import { ChevronRightIcon, ChevronUpIcon } from '@primer/octicons-react';
import { Box, IconButton } from '@primer/react';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import DataTable from '../../components/ui/data-table';
import { IColumn } from '../../components/ui/data-table/DataTable';
import { useThongKeSiSo } from '../../hooks/useThongKeSiSo';
import { actions } from '../../state/actions/actionsWrapper';
const mainAction = actions.thongKe.thongKeSiSo;
const ThongKeSiSoDataTable = () => {
    const { dataStructed, expandedIds, dmTrangThais } = useThongKeSiSo();
    const dispatch = useDispatch();
    const dataSource = useMemo(() => {
        let result: any[] = [];

        let dangTheoHocId: number | undefined;
        let dangTheoHocCoDieuKienId: number | undefined;
        dmTrangThais.forEach((value) => {
            const name = (value.dm_trangthaihocsinh_name || '').toLowerCase().trim();
            if (name === 'đang học') {
                dangTheoHocId = value.dm_trangthaihocsinh_id;
            }
            if (name === 'đang theo học có điều kiện') {
                dangTheoHocCoDieuKienId = value.dm_trangthaihocsinh_id;
            }
        });

        const calcHienHuu = (row: any) => {
            // Chỉ tính "Đang học" (không bao gồm "Đang theo học có điều kiện")
            let hienHuu = dangTheoHocId !== undefined ? (row[`T_${dangTheoHocId}`] || 0) : 0;
            // Fallback: nếu không có dữ liệu trạng thái (hienHuu = 0 và không có giá trị T_* nào), sử dụng si_so trực tiếp
            if (hienHuu === 0) {
                // Kiểm tra xem có bất kỳ giá trị T_* nào không
                const hasTrangThaiData = Object.keys(row).some(key => key.startsWith('T_') && row[key] > 0);
                if (!hasTrangThaiData) {
                    hienHuu = row.si_so || 0;
                }
            }
            return hienHuu;
        };

        dataStructed.forEach((_truong, _truongId) => {
            const truongId = _truongId;
            let itemTruong: any = {
                ..._truong,
                id: truongId,
                items: [],
                trangThaiSum: undefined
            }
            _truong.trangThaiSum.forEach((value, key) => {
                itemTruong[`T_${key}`] = value;
            })
            itemTruong.hoc_sinh_hien_huu = calcHienHuu(itemTruong);
            result.push(itemTruong)
            if (expandedIds.has(truongId)) {
                _truong.items.forEach((_khoi, _khoiId) => {
                    const khoiId = `${truongId}_${_khoiId}`;
                    let itemKhoi: any = {
                        ..._khoi,
                        id: khoiId,
                        items: [],
                        trangThaiSum: undefined
                    }
                    _khoi.trangThaiSum.forEach((value, key) => {
                        itemKhoi[`T_${key}`] = value;
                    })
                    itemKhoi.hoc_sinh_hien_huu = calcHienHuu(itemKhoi);
                    result.push(itemKhoi)
                    if (expandedIds.has(khoiId)) {
                        _khoi.items.forEach((_he, _heId) => {
                            const heId = `${khoiId}_${_heId}`;
                            let itemHe: any = {
                                ..._he,
                                id: heId,
                                items: [],
                                trangThaiSum: undefined
                            }
                            _he.trangThaiSum.forEach((value, key) => {
                                itemHe[`T_${key}`] = value;
                            })
                            itemHe.hoc_sinh_hien_huu = calcHienHuu(itemHe);
                            result.push(itemHe)
                            if (expandedIds.has(heId)) {
                                _he.items.forEach((_lop, _lopId) => {
                                    let itemLop: any = {
                                        ..._lop,
                                        id: _lopId,
                                        items: [],
                                        trangThaiSum: undefined
                                    }
                                    _lop.trangThaiSum.forEach((value, key) => {
                                        itemLop[`T_${key}`] = value;
                                    })
                                    itemLop.hoc_sinh_hien_huu = calcHienHuu(itemLop);
                                    result.push(itemLop)
                                })
                            }
                        })
                    }
                })

            }
        })
        return result;
    }, [dataStructed, expandedIds, dmTrangThais])


    const columns: IColumn[] = useMemo(() => {
        let result: IColumn[] = [
            {
                dataField: "name",
                caption: "Trường/ Khối/ Hệ/ Lớp",
                isMainColumn: true,
                width: "150px",
                cellRender: (data: any) => {
                    const isExpanded = expandedIds.has(data.id);
                    const type = data.type;
                    let level = 0;
                    if (type === "khoi") level = 1;
                    if (type === "he") level = 2;
                    if (type === "lop") level = 3;
                    return (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Box sx={{ width: `${(level) * 30}px` }}>
                                &nbsp;
                            </Box>
                            {type !== "lop" &&
                                <IconButton icon={!isExpanded ? ChevronRightIcon : ChevronUpIcon}
                                    aria-label=''
                                    variant='invisible'
                                    size='small'
                                    onClick={() => {
                                        let newMap = new Map(expandedIds);
                                        if (isExpanded) {
                                            newMap.delete(data.id)
                                        } else {
                                            newMap.set(data.id, data.id)
                                        }
                                        dispatch(mainAction.CHANGE_EXPANDED_IDS(newMap))
                                    }}
                                />
                            }
                            <Box>
                                {data.name}
                            </Box>
                        </Box>
                    );
                }
            },
            {
                dataField: "hoc_sinh_hien_huu",
                caption: "Hiện hữu",
                align: "right",
                width: "100px"
            }
        ]

        let dangTheoHocId: number | undefined;
        let dangTheoHocCoDieuKienId: number | undefined;
        const otherTrangThais: any[] = [];

        dmTrangThais.forEach((value) => {
            const name = (value.dm_trangthaihocsinh_name || '').toLowerCase().trim();
            if (name === 'đang học') {
                dangTheoHocId = value.dm_trangthaihocsinh_id;
            } else if (name === 'đang theo học có điều kiện') {
                dangTheoHocCoDieuKienId = value.dm_trangthaihocsinh_id;
            } else {
                otherTrangThais.push(value);
            }
        });

        if (dangTheoHocId !== undefined) {
            const trangThai = dmTrangThais.get(dangTheoHocId);
            if (trangThai) {
                result.push({
                    dataField: `T_${dangTheoHocId}`,
                    caption: trangThai.dm_trangthaihocsinh_name,
                    align: "right",
                    width: "100px"
                });
            }
        }

        if (dangTheoHocCoDieuKienId !== undefined) {
            const trangThai = dmTrangThais.get(dangTheoHocCoDieuKienId);
            if (trangThai) {
                result.push({
                    dataField: `T_${dangTheoHocCoDieuKienId}`,
                    caption: trangThai.dm_trangthaihocsinh_name,
                    align: "right",
                    width: "100px"
                });
            }
        }

        otherTrangThais.forEach((value) => {
            result.push({
                dataField: `T_${value.dm_trangthaihocsinh_id}`,
                caption: value.dm_trangthaihocsinh_name,
                align: "right",
                width: "100px"
            });
        });

        result.push({
            dataField: "si_so",
            caption: "Tổng số",
            align: "right",
            width: "100px"
        })
        return result;
    }, [dmTrangThais, expandedIds])
    return (
        <>
            <DataTable
                data={dataSource}
                columns={columns}
            />
        </>
    );
};

export default ThongKeSiSoDataTable;
